import React from 'react';
import {
  getApprovalStatusClass,
  getApprovalStatusLabel,
  getSettlementStatusClass,
  getSettlementStatusLabel,
} from '../../utils/saleStatusAdapter';

/**
 * Renders approval and settlement status badges for a sale.
 * @param {{ sale: object, compact?: boolean, className?: string }} props
 */
const SaleScopedStatusBadges = ({ sale, compact = false, className = '' }) => {
  if (compact) {
    return (
      <div className={`d-flex flex-column gap-1 ${className}`.trim()}>
        <div className="small">
          <span className="text-muted me-1">Aprobación:</span>
          <span className={`sale-status-badge ${getApprovalStatusClass(sale)}`}>
            {getApprovalStatusLabel(sale)}
          </span>
        </div>
        <div className="small">
          <span className="text-muted me-1">Liquidación:</span>
          {getSettlementStatusLabel(sale) === '—' ? (
            <span className="text-muted">—</span>
          ) : (
            <span className={`sale-status-badge ${getSettlementStatusClass(sale)}`}>
              {getSettlementStatusLabel(sale)}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`d-flex flex-column gap-1 align-items-center ${className}`.trim()}>
      <span className={`sale-status-badge ${getApprovalStatusClass(sale)}`}>
        {getApprovalStatusLabel(sale)}
      </span>
      {getSettlementStatusLabel(sale) === '—' ? (
        <span className="text-muted small">—</span>
      ) : (
        <span className={`sale-status-badge ${getSettlementStatusClass(sale)}`}>
          {getSettlementStatusLabel(sale)}
        </span>
      )}
    </div>
  );
};

export default SaleScopedStatusBadges;
